// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"ce7d3662","306":"99b85868"}[chunkId] + ".chunk.css";
};